import {User} from '../Types'

export function isUserEqual (u1: User|null, u2: User): boolean {
    if (u1 === null)
        return false
    return JSON.stringify(u1) === JSON.stringify(u2) 
}